export default {
  id: null,
  type: '', // atatchment, speaker_recording, slides_recording
  file_name: '',
  size_b: 0,
  deleted: false,
};
